import tooltipNamntryck from '../../../../assets/cls-fi/products/pdp-tooltips/tryk-navn-logo.jpg';
import tooltipSpecialTekst from '../../../../assets/cls-fi/products/pdp-tooltips/example_special-tekst.jpg';
import tooltipFlag from '../../../../assets/cls-fi/products/pdp-tooltips/example_flag_print.jpg';
import tooltipBogstav from '../../../../assets/cls-fi/products/pdp-tooltips/example_klassens_bogstav.jpg';
import tooltipBrösttryck from '../../../../assets/cls-fi/products/pdp-tooltips/example_lille_brysttryk.jpg';
import tooltipRyggtryck from '../../../../assets/cls-fi/products/pdp-tooltips/rygtryk_a4.jpg';

export const ADDON_TOOLTIPS = {
  navnetryk: {
    title: 'Esimerkki nimipainatuksesta',
    image: tooltipNamntryck,
    description: 'Tässä voit lisätä nimipainatuksen. Mukaan mahtuu enintään 16 merkkiä välilyönnit mukaan lukien. Nimi sijoitetaan toiselle rintapuolelle. Huomaa, että erikoismerkit kuten kiinalaiset merkit eivät ole mahdollisia.\n\n(Tarkista, että nimesi on kirjoitettu oikein – sekä tässä että piirroksessa, joka tehdään selkäpainatusta varten)',
  },
  specialTekst: {
    title: 'Esimerkki erikoistekstistä',
    image: tooltipSpecialTekst,
    description: 'Esim. Instagram-nimi tai lempinimi. Teksti painetaan hihaan. Enintään 16 merkkiä välilyönnit mukaan lukien.',
  },
  flag: {
    title: 'Esimerkki lipusta',
    image: tooltipFlag,
    description: 'Valitse lippu, joka painetaan paitasi hihaan. Lippu on noin 3×2 cm.',
  },
  klassensBogstav: {
    title: 'Esimerkki luokan kirjaimesta',
    image: tooltipBogstav,
    description: 'Luokan kirjain brodeerataan hihaan. Valitse kirjain, joka sopii luokallesi.',
  },
  lilleBrösttryck: {
    title: 'Esimerkki pienestä rintapainatuksesta',
    image: tooltipBrösttryck,
    description: 'Koulun logo tai oma logo (painatus) sijoitetaan rinnalle. Huomaa, että tämä on painatus – ei brodeeraus.',
  },
  rygtryk: {
    title: 'Esimerkki selkäpainatuksesta',
    image: tooltipRyggtryck,
    description: 'Ainutlaatuinen design luokallesi, joka painetaan paidan selkään. Voit valita A4- ja A3-koon väliltä.',
  },
};
